import { EditTwoTone, LinkOutlined } from "@ant-design/icons";
import moment from "moment";
import React, { useContext, useState } from "react";
import "./ResourceHistoryCard.css";
import { Popover } from "antd";

import ResourceInputModal from "../../components/ResourceInputModal";
import DrawerTask from "~/components/DrawerTask/DrawerTask";
import { StatusesRoutes, TaskRoutes } from "~/http/routes";
import { useSelector } from "react-redux";
import { userSelector } from "~/redux/Selectors";
import { ToastContext } from "~/providers/ToastProvider";

function ResourceHistoryCard({
  data,
  handleAddResourceInput,
  isOutput,
  isEditable,
}) {
  const [modalShow, setModalShow] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDrawerLoading, setIsDrawerLoading] = useState(false);
  const [resourceInputInfo, setResourceInputInfo] = useState(false);
  const [selectedTask, setSelectedTask] = useState({});
  const { companyId, subprojectId } = useSelector(userSelector);
  const { setToast } = useContext(ToastContext);

  const formattedValue = (value) =>
    new Intl.NumberFormat("pt-BR").format(value);

  async function handleRowClick(task_id) {
    setIsDrawerLoading(true);
    setIsDrawerOpen(true);

    try {
      const res = await TaskRoutes.getTask(subprojectId, task_id);
      const task = res.data.data;
      const statusRes = await StatusesRoutes.getStatus(
        companyId,
        task.subproject_id,
      );
      task.statuses = statusRes.data.data;

      setSelectedTask(task);
    } catch (err) {
      setIsDrawerOpen(false);

      setToast({
        type: "error",
        title: "Erro!",
        message: "Um erro ocorreu ao exibir a tarefa selecionada!",
        show: true,
        autohide: true,
      });
    }

    setIsDrawerLoading(false);
  }

  return (
    <div className="card-container-history">
      <ResourceInputModal
        open={modalShow}
        onCancel={() => {
          setModalShow(false);
        }}
        initialEditingValues={resourceInputInfo}
        onSuccess={handleAddResourceInput}
      />
      <DrawerTask
        show={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        data={selectedTask}
        // changeTaskValue={handleTaskValueChange}
        // handleEditTask={handleTaskEdit}
        loading={isDrawerLoading}
      />
      <div className="card-left-side">
        <div className="card-line"></div>
        <div
          className="card-circle"
          style={{
            backgroundColor: isOutput ? "orange" : "var(--blue-color)",
          }}
        ></div>
      </div>
      {isOutput ? (
        <div className="paper-card-output">
          <div className="paper-card-info">
            <span className="card-row-info">
              <b>ID operação: </b>
              {data.id}
            </span>
            <span className="card-row-info">
              <b>Quantidade: </b>
              {formattedValue(data.quantity)}
            </span>
            <span className="card-row-info">
              <b>Responsável:</b> {data.username}
            </span>
          </div>
          <div className="paper-card-info">
            <span className="card-row-info">
              <b>ID Tarefa:</b> {data.task_id}
            </span>
            <span className="card-row-info">
              <b>Projeto:</b> {data.project_name}
            </span>
            <span className="card-row-info">
              <b>Subprojeto:</b> {data.subproject_name}
            </span>
          </div>
          <div className="paper-card-info">
            <span className="card-row-info">
              <b>Criação:</b> {moment(data.created_at).format("DD/MM/YYYY")}
            </span>
            <span className="card-row-info">
              <b>Última atualização:</b>{" "}
              {moment(data.updated_at).format("DD/MM/YYYY HH:mm")}
            </span>
          </div>

          <>
            <div></div>

            <div className="d-flex">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  opacity: isEditable ? 1 : 0.5,
                  pointerEvents: isEditable ? "auto" : "none",
                }}
                onClick={() => {
                  if (isEditable) {
                    handleRowClick(data.task_id);
                  }
                }}
              >
                <Popover placement="top" content="Editar Saída">
                  <EditTwoTone style={{ fontSize: "24px" }} />
                </Popover>
              </div>
            </div>
          </>
        </div>
      ) : (
        <div className="paper-card">
          <div className="paper-card-info">
            <span className="card-row-info">
              <b>ID operação: </b>
              {data.id}
            </span>

            <span className="card-row-info">
              <b>Quantidade: </b>
              {formattedValue(data.quantity)}
            </span>

            <span className="card-row-info">
              <b>Documento:</b> {data.invoice ?? " -"}
            </span>

            <span className="card-row-info">
              <b>Responsável:</b> {data.username}
            </span>
            <span className="card-row-info">
              <b>Criação:</b> {moment(data.created_at).format("DD/MM/YYYY")}
            </span>
          </div>
          <div className="paper-card-info">
            <span className="card-row-info">
              <b>Data Entrada:</b>{" "}
              {moment(data.input_date ?? data.created_at).format("DD/MM/YYYY")}
            </span>

            <span className="card-row-info">
              <b>Última atualização:</b>{" "}
              {moment(data.updated_at).format("DD/MM/YYYY HH:mm")}
            </span>

            <span className="card-row-info">
              <b>Descrição:</b> {data.description ?? " -"}
            </span>
            {data.attachments?.length > 0 &&
              data.attachments.map((item, i) => (
                <span className="card-row-info">
                  <Popover
                    placement="top"
                    showArrow={false}
                    content={item.name}
                  >
                    <b className="mr-2">Arquivo:</b>
                    <a
                      style={{ marginTop: "5px" }}
                      key={item.id}
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <LinkOutlined style={{ fontSize: "22px" }} />
                    </a>
                  </Popover>
                </span>
              ))}
          </div>

          <>
            <div className="paper-card-info">
              <h5>
                {data.additional_fields?.length > 0 ? "Campos Adicionais:" : ""}
              </h5>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                {data.additional_fields?.map((item, i) => (
                  <div
                    key={item.id}
                    style={{
                      margin: "5px",
                      borderRadius: "5px",
                      border: "2px solid var(--blue-color)",
                      minWidth: "100px",
                      paddingInline: "7px",
                    }}
                  >
                    <b>{item.resources_field?.name}</b>: {item.value}
                  </div>
                ))}
              </div>
            </div>

            <div className="d-flex">
              <div
                onClick={() => {
                  if (!isEditable) return;
                  setResourceInputInfo({
                    id: data.id,
                    resource_id: data.resource_id,
                    name: data.resource_name,
                    additional_fields: data.additional_fields.map((item) => ({
                      id: item.id,
                      name: item.resources_field?.name,
                      value: item.value,
                    })),
                    description: data.description,
                    quantity: String(data.quantity),
                    invoice: data.invoice,
                    input_date: data.input_date,
                    attachments: data.attachments,
                  });
                  setModalShow(true);
                }}
                style={{
                  display: "flex",
                  cursor: "pointer",
                  alignItems: "center",
                  opacity: isEditable ? 1 : 0.5,
                  pointerEvents: isEditable ? "auto" : "none",
                }}
              >
                <Popover placement="top" content="Editar Entrada">
                  <EditTwoTone style={{ fontSize: "24px" }} />
                </Popover>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default ResourceHistoryCard;
